export async function downloadExportFile(tokenRequest) {
  const { data } = await tokenRequest
  window.location.href = process.env.VUE_APP_REPORTS_API_ORIGIN + data.url
}
